import * as React from "react";
import { Route, useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import PageFooter from "../components/PageFooter";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../store";
import parse from "html-react-parser";
import { Container } from "reactstrap";
import { useEffect, useState } from "react";
import * as ConfigurationActions from "../store/configurationService/actions";
import { useLocation, BrowserRouter as Router } from "react-router-dom";
import BannerMessage from "../components/Dashboard/BannerMessage";
import { useTranslation } from "react-i18next";

interface IDefaultProps {
    component: any;
    path?: string;
    exact?: boolean;
}
let isRedirect = true;
const LoginLayout: React.SFC<IDefaultProps> = (props) => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const RetailerCode: any = query.get("RetailerCode") || query.get("RETAILERCODE");
    const LookupValue: any = query.get("VALUE");
    const LookupType: any = query.get("Type");
    const redirectToken = query.get("Redirect") || query.get("REDIRECT") || query.get("redirect");
    const { component: Component, ...rest } = props;
    const dispatch = useDispatch();
    const history: any = useHistory();
    const [partnerName, setPartnerName] = useState("");
    const isCustomPath: boolean = ((props?.path?.toLowerCase().includes("system-error") || props?.path?.toLowerCase().includes("register/error")) === true);
    const requesPartnerConfig = () => dispatch(ConfigurationActions.actionCreators.requestPartnerConfig(RetailerCode, LookupType, LookupValue));
    const partnerDisplayName: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerDisplayName
            ? state.configurationState.configuration.partnerConfig.partnerDisplayName
            : ""
    );

    const loggedInActiveAccount = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount ? state.loggedInUser.activeAccount : null
    );
    const isLife360PartnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 539
                ? true
                : false
            : false
    );
    const isDeluxeProventId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 34
                ? true
                : false
            : false
    );
    const isTUIDFPartnerId = useSelector((state: ApplicationState) =>
    state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
        ? state.configurationState.configuration.partnerConfig.partnerId === 2649
            ? true
            : false
        : false
);
    const fromLogout = history && history.location.state ? history.location.state.from : "";
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );
    const partnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : ""
    );
    const { t: tLang, i18n: i18nLang } = useTranslation();
    let currentPathLoc = useLocation();

    const isMetLifePartnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2573
                ? true
                : false
            : false
    );

    const isCreditSesamePartnerId= useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2626
                ? true
                : false
            : false
    );

    const isFrenchOnlyPartner: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isFrenchOnlyPartner
            ? state.configurationState.configuration.partnerConfig.isFrenchOnlyPartner
            : false
    );

    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );

    const [language, setLanguage] = React.useState<string>("en");

    const getCookie = (name: string): string | undefined => {
        const match = document.cookie
        .split(";")
        .map(c => c.trim())
        .find(c => c.startsWith(name + "="));
        return match ? match.split("=")[1]?.trim() : undefined;
    };

    const getPreferredLanguage = (): string => {
        const defaultLanguage = "en";

        const userPreferred = getCookie("user_prefered_language");
        const preferred = getCookie("preferredLanguage");

        // User has already chosen a language (cookie takes priority)
        if (userPreferred === "en" || userPreferred === "fr") {
            return userPreferred;
        }

        // If preferredLanguage cookie exists, use it
        if (preferred === "en" || preferred === "fr") {
            // write to user_prefered_language for consistency
            document.cookie = `user_prefered_language=${preferred};path=/`;
            return preferred;
        }

        // If French-only partner and no prior choice, default to "fr"
        if (isFrenchOnlyPartner) {
            document.cookie = `user_prefered_language=fr;path=/`;
            return "fr";
        }

        return defaultLanguage;
    };

    const setUserPreferedLanguage = (newLanguage: string) => {
        if (newLanguage !== "en" && newLanguage !== "fr") return;

        document.cookie = "user_prefered_language=" + newLanguage + ";path=/";
        sessionStorage.setItem("preferredLanguage", newLanguage);
        setLanguage(newLanguage);

        // Close user menu safely
        const toggleUser: any = document.querySelector("#user-profile-btn");
        const userMenu: any = document.querySelector("#user-profile");

        if (userMenu) userMenu.classList.remove("is-active");
        if (toggleUser) toggleUser.setAttribute("aria-expanded", "false");
    };

    useEffect(() => {
        if (!fromLogout) {
            requesPartnerConfig();
            if (redirectToken && isRedirect) {
                isRedirect = false;
                dispatch(ConfigurationActions.actionCreators.getRedirectTokenAction(redirectToken.replace(/"/g, "")));
            }
        }
    }, []);

    useEffect(() => {
        if (!partnerLanguageOptions) return;
        if (isFrenchOnlyPartner === undefined) return;

        const resolvedLanguage = getPreferredLanguage();
        setLanguage(resolvedLanguage);
    }, [partnerLanguageOptions, isFrenchOnlyPartner]);

    useEffect(() => {
        if (!partnerLanguageOptions) return;
        if (isFrenchOnlyPartner === undefined) return;

        const resolvedLanguage =
            partnerLanguageOptions && partnerLanguageOptions.length > 1
                ? language
                : (isFrenchOnlyPartner ? "fr" : "en");
        sessionStorage.setItem("preferredLanguage", resolvedLanguage);
        i18nLang.changeLanguage(resolvedLanguage);
    }, [language, fromLogout, isFrenchOnlyPartner, partnerLanguageOptions]);

    useEffect(() => {
        if (partnerId === 2649) {
            setPartnerName("Transunion");
        } else {
            setPartnerName(partnerDisplayName ?? "");
        }

        if (partnerId) {
            const resolvedLanguage = getPreferredLanguage();
            setLanguage(resolvedLanguage);
            sessionStorage.setItem("preferredLanguage", resolvedLanguage);
            i18nLang.changeLanguage(resolvedLanguage);
        }
    }, [partnerId, partnerDisplayName]);

    const toggleLanguageSelectionWidget = () => {
        const toggleUser: any = document.querySelector("#user-profile-btn");
        const userMenu: any = document.querySelector("#user-profile");
        userMenu.classList.add("is-active");
        toggleUser.setAttribute("aria-expanded", true);
    };

    const brandingOptions = useSelector((state: ApplicationState) => {
        if (state.configurationState && state.configurationState.configuration?.partnerConfig?.brandingOption?.imagePath) {
            return {
                imagePath: state.configurationState.configuration?.partnerConfig?.brandingOption?.imagePath,
                associationText: state.configurationState.configuration?.partnerConfig?.brandingOption?.associationText,
                secondaryText: state.configurationState.configuration?.partnerConfig?.brandingOption?.secondaryText,
                originalSiteUrl: state.configurationState.configuration?.partnerConfig?.originSiteUrl,
            };
        } else {
            return {
                imagePath: "",
                associationText: "",
                secondaryText: "",
                originalSiteUrl: "",
            };
        }
    });
    const renderLogo = () => {
        if(!loggedInActiveAccount || !loggedInActiveAccount.accountType) {
            if(isLife360PartnerId) {
                return (<a href={"#"} onClick={(e) => e.preventDefault()} title="Go to Homepage" className="logo-link">
                    <img
                        src={brandingOptions?.imagePath}
                        alt={isMetLifePartnerId ? "MetLife Legal Plans Logo" : `${partnerName} Logo`}
                    />
                </a>);
            }

            if(isTUIDFPartnerId) {
               return (<a className="logo-link">
                <img
                    src={brandingOptions?.imagePath}
                    alt={`${partnerName} Logo`}
                />
            </a>)
            }

            if(isCreditSesamePartnerId){
                return(<></>);
            }

            return (
                <a href={"https://" + brandingOptions.originalSiteUrl} title="Go to Homepage" className="logo-link">
                    <img
                        src={brandingOptions?.imagePath}
                        alt={isMetLifePartnerId ? "MetLife Legal Plans Logo" : `${partnerName} Logo`}
                    />
                </a>
            );
        }
    };

    const showCustomErrorPage = useSelector(
        (state: ApplicationState) =>
            (state.configurationState &&
                state.configurationState.configuration &&
                state.configurationState.configuration.partnerConfig &&
                state.configurationState.configuration.partnerConfig.ssoOptions &&
                state.configurationState.configuration.partnerConfig.ssoOptions.showCustomErrorPage) ||
            false
    );

    return (
        <Route
            {...rest}
            render={(matchProps) => (
                <React.Fragment>
                    {isDeluxeProventId &&
                        <Helmet>
                            <meta name="robots" content="noindex" />
                        </Helmet>
                    }
                    <div className="l-page-holder">
                        {showCustomErrorPage && isCustomPath ? <main id="main-page-content">
                            <div
                                className={`l-page-container ${!partnerDisplayName && "loading"}`}
                                id="title-page-login-layout"
                            >
                                {partnerDisplayName && (
                                    <Container>
                                        <Component {...matchProps} />
                                    </Container>
                                )}
                            </div>
                        </main> :
                        <div>
                        <header>
                            {/* <a className="skip-main" href="#content">Skip to Main Content</a> */}
                            <div className="l-page-container">
                                <div className={renderSiteInIFrame ? "" : "row between-xs full-width"} style={{ display: renderSiteInIFrame ? "none" : "" }}>
                                    <div className="col-xs flex-grow-null">
                                        <div className="row middle-xs">
                                            {Boolean(brandingOptions?.imagePath) && (
                                                <div className="col-no-gutter hide-mobile">
                                                    <div className="logo-container">
                                                        {renderLogo()}
                                                        {loggedInActiveAccount && loggedInActiveAccount.accountType && !isCreditSesamePartnerId && (
                                                            <a href="dashboard" title="Go to Homepage" className="logo-link">

                                                                <img
                                                                    src={brandingOptions?.imagePath}
                                                                    alt={isMetLifePartnerId ? "MetLife Legal Plans Logo" : `${partnerName} Logo`}
                                                                />
                                                            </a>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                            <div className="col-no-gutter hide-mobile">
                                                <div className="secondary-container">
                                                    <div className="secondary-text">{brandingOptions?.associationText}</div>
                                                    <div className="secondary-logo">{parse(brandingOptions?.secondaryText || "", {})}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {!!partnerLanguageOptions && partnerLanguageOptions.length > 1 && (
                                        <div className="col-xs flex-grow-null">
                                            <div className="user-container">
                                                <div className="m-pop-under">
                                                    <ul className="list-reset list-inline">
                                                        <li style={{ margin: "10px" }}>
                                                            <strong>
                                                                        <span>{tLang("login.selectLanguage")}</span>
                                                            </strong>
                                                        </li>
                                                        <li className="btn-footer-language">
                                                            <button
                                                                type="button"
                                                                className="btn-default btn-icon-left btn-pop-under user-button"
                                                                id="user-profile-btn"
                                                                aria-expanded="false"
                                                                aria-controls="user-profile-options"
                                                                onClick={() => toggleLanguageSelectionWidget()}
                                                            >
                                                                <em className="las la-globe"></em>
                                                                <span className="margin-left-xs margin-right-xs">{language === "en" ? "English" : "French"}</span>
                                                            </button>
                                                        </li>
                                                    </ul>

                                                    <div
                                                        id="user-profile"
                                                        className="pop-under-content user-profile"
                                                        style={{ width: "max-content" }}
                                                    >
                                                        <div>
                                                            <h4 className="sr-only">User Options</h4>
                                                            <ul role="menu" className="submenu-links" style={{ padding: "10px" }}>
                                                                {!!partnerLanguageOptions ? (
                                                                    partnerLanguageOptions.map((languageObject: any, index: number) => {
                                                                        return (
                                                                            <li
                                                                                role="presentation"
                                                                                key={languageObject.code}
                                                                                className={`${index !== partnerLanguageOptions.length - 1 && "margin-bottom-m"} ${language === languageObject.code.toLowerCase()
                                                                                        ? "status-active"
                                                                                        : "status-inactive"
                                                                                    }`}
                                                                            >
                                                                                <span
                                                                                    className="hand-pointer"
                                                                                    role="menuitem"
                                                                                    onClick={(e) => {
                                                                                        setUserPreferedLanguage(languageObject.code.toLowerCase());
                                                                                        document.documentElement.lang = languageObject.code.toLowerCase();
                                                                                    }}
                                                                                >
                                                                                    <em className="las la-globe"></em>
                                                                                    <span style={{ marginLeft: "10px" }}>{languageObject.displayName}</span>
                                                                                </span>
                                                                            </li>
                                                                        );
                                                                    })
                                                                ) : (
                                                                    <li
                                                                        role="presentation"
                                                                        className={`margin-bottom-m ${language === "en" ? "status-active" : "status-inactive"}`}
                                                                    >
                                                                        <span
                                                                            className="hand-pointer"
                                                                            role="menuitem"
                                                                            onClick={(e) => {
                                                                                setUserPreferedLanguage("en");
                                                                            }}
                                                                        >
                                                                            <em className="las la-globe"></em>
                                                                            <span style={{ marginLeft: "10px" }}>English</span>
                                                                        </span>
                                                                    </li>
                                                                )}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </header>
                        <BannerMessage layout={"login"} />
                        {
                            <main id="main-page-content">
                                <div
                                    className={`l-page-container ${!partnerDisplayName && "loading"}`}
                                    id="title-page-login-layout"
                                >
                                    {partnerDisplayName && (
                                        <Container>
                                            <Component {...matchProps} />
                                        </Container>
                                    )}
                                </div>
                            </main>
                        }
                                {!renderSiteInIFrame && partnerId && <PageFooter />}
                        </div>
                        }
                    </div>
                </React.Fragment>
            )}
        />
    );
};

export default LoginLayout;
